
<template>
  <router-btn :text="$t('servicesystem.common_objects.logg.new_logg')"
              :icon="'mdi-timeline-text'"
              :color="'quaternary'"
              :disabled="false"
              :outlined="false"
              :textbtn="textbtn"
              :large="large"
              :small="small"
              @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewLoggBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      this.$store.dispatch("triggerevents/triggerLogg");
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
